/**
 * The third-party CMP script is injected asynchronously and exposes its API
 * on `window.ours_consent`. this guards against it being undefined.
 */
declare global {
  interface Window {
    ours_consent?: {
      showPreferences: () => void;
      acceptAll: () => void;
      hide: () => void;
    };
  }
}

/** Returns true once the CMP script has loaded and exposed its API on the window. */
export const isCmpAvailable = (): boolean => typeof window !== "undefined" && typeof window.ours_consent?.showPreferences === "function";
